import React, { useCallback, useContext, useMemo } from 'react';
import styled from 'styled-components';
import { useField } from 'react-final-form';
import { Table as BaseTable, SelectHeader } from '@ubeya/shared-web/components';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';

const Select = styled(SelectHeader)`
  > .select {
    width: auto;
  }
`;

const Table = styled(BaseTable)`
  .header.cell {
    padding-top: 8px;
    padding-bottom: 8px;
  }

  .row.error {
    background-color: ${({ theme }) => theme.colors.redExtraLight};
  }
`;

const ConfigureColumns = () => {
  const { t } = useContext(ConfigContext);
  const {
    input: { value: data }
  } = useField('file');

  const {
    input: { value: columnsMap, onChange: setColumnsMap }
  } = useField('columns');

  const allColumnsOptions = useMemo(
    () =>
      ['name', 'identifier'].map((column) => ({
        value: column,
        label: t(column === 'name' ? 'costCenterName' : 'costCenterIdentifier')
      })),
    [t]
  );

  const columns = useMemo(
    () =>
      Object.keys(data[0]).map((key, index) => ({
        Header: () => (
          <Select
            value={columnsMap[index]}
            onChange={(value) => setColumnsMap({ ...columnsMap, [index]: value })}
            options={allColumnsOptions}
            usePortal
          />
        ),
        dataKey: key,
        formatter: (value) => value?.toString?.()
      })),
    [allColumnsOptions, columnsMap, data, setColumnsMap]
  );

  const validateData = useCallback(
    (costCenter) => {
      const formattedCostCenter = Object.entries(costCenter).reduce((prev, [key, value], index) => {
        const selectedKey = columnsMap?.[index] || key;
        return { ...prev, [selectedKey]: value };
      }, {});

      // Validate that both name and identifier are present
      if (!formattedCostCenter.name || !formattedCostCenter.identifier) {
        return 'error';
      }

      return '';
    },
    [columnsMap]
  );

  return <Table data={data} columns={columns} rowStyle={validateData} resizable />;
};

export default ConfigureColumns;
